module.exports = __webpack_public_path__ + "static/media/icon_warming.548f10c4.svg";